// Deep-link route for `/triage/runs/{runId}` — preserved for backward
// compatibility with bookmarks and shared links predating DEV-16210.
//
// The run-detail surface is now a dialog over the triage board (which
// itself lives at `/inbox/board` since the 2026-07 nav review), so this
// route's only job is to redirect into the board with `?runId=<id>`.
// The board reads `runId` from its search params and opens the dialog
// automatically.
//
// We pick `replace: true` so the back button skips this URL entirely —
// the user came in via a deep link, and we don't want them stuck in a
// two-entry history (deep link → board) when they hit back.
import { createFileRoute, redirect } from '@tanstack/react-router';

import { routes } from '../../../lib/constants';

export const Route = createFileRoute('/triage/runs/$runId')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: routes.INBOX_BOARD,
      search: { runId: params.runId },
      replace: true,
    });
  },
  // Component never renders — the redirect fires in `beforeLoad` before
  // mount. Kept as a Fragment so the file is a valid route module.
  component: () => null,
});
